import { ValidationResult } from '../formField/types/form-validator';

/**
 * Returns true if any of value or joinedValue result is true
 * @param {() => boolean} joinedValue
 * @param {string} errorMessage
 * @returns {(value: boolean) => Promise<ValidationResult>}
 * @constructor
 */
export const CustomInclusiveDisjunctionValidator = (joinedValue: () => boolean, errorMessage: string) => {
  return async (value: boolean): Promise<ValidationResult> => {
    if (value || joinedValue()) {
      return { valid: true };
    }

    return { valid: false, error: errorMessage };
  };
};
